import React from 'react';

import Field from '../layout/Field.jsx';
import ContentContainer from '../layout/ContentContainer.jsx';
import SectionContainer from '../layout/SectionContainer.jsx';
import SectionNav from '../layout/SectionNav.jsx';

const FieldSection = ({
	Registry,
	// name,
	fields = [],
	values,
	title,
	errors,
	onChange,
	navigationProps,
	selectedLanguage = 'EN',
	disabled = false,
	style = {},
}) => {
	const Fields = fields.map((field, i) => (
		<Field
			Registry={Registry}
			{...field}
			key={`${field.name}-${i}`}
			onChange={onChange}
			values={values}
			errors={errors}
			disabled={disabled}
		/>
	));

	return (
		<SectionContainer
			style={style}
			Navigation={<SectionNav selectedLanguage={selectedLanguage} {...navigationProps} />}
		>
			<ContentContainer>
				{title && (
					<h2 className="nf-section-title" key={title.replace(' ', '-')}>
						{title}
					</h2>
				)}
				{Fields}
			</ContentContainer>
		</SectionContainer>
	);
};

FieldSection.type = 'FieldSection';
FieldSection.hasNavigation = true;
FieldSection.spec = [
	{
		name: 'FieldSection',
		key: 'FieldSection',
		title: 'Collection of fields',
		allowedFields: [
			'Signature',
			'DatePicker',
			'Checkbox',
			'Image',
			'Link',
			'Typography',
			'VideoPlayer',
			'TextField',
			'TextArea',
			'ScrollableContentViewer',
		],
		translatable: ['title', 'navigation.previousLabel', 'navigation.nextLabel', 'navigation.submitLabel'],
		fields: [
			{
				type: 'TextField',
				name: 'title',
				label: 'Section title',
			},
			{
				type: 'TextField',
				name: 'navigation.previousLabel',
				label: 'Previous label',
				helperText: 'if there is a previous section, this will be the label to go back.',
			},
			{
				type: 'TextField',
				name: 'navigation.nextLabel',
				label: 'Next label',
				helperText: 'if there is a next section, this will be the label to go forward.',
			},
			{
				type: 'TextField',
				name: 'navigation.submitLabel',
				label: 'Submit label',
				helperText: 'If this section is the last section, this will be the text on the submit button.',
			},
		],
		defaultProperties: {
			title: 'Section title',
			navigation: {
				previousLabel: 'Previous',
				nextLabel: 'Next',
				submitLabel: 'Submit',
			},
		},
	},
];

export default FieldSection;
